import { SET_CLIENT_DONATE } from "../actions/action-types.js";

export default function clientDonate(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_DONATE:
            return (state = payload)
        default:
            return state
    }
}